import { Icon } from "../Icon";
import { IIcon } from "../interfaces/IIcon";

// Legacy icon yet to be normalised to a 64 viewBox, ignoring rule for now.
// eslint-disable-next-line @pebblepad/icon-is-valid
export const informationIcon: IIcon = new Icon(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 22c5.514 0 10-4.486 10-10S17.514 2 12 2 2 6.486 2 12s4.486 10 10 10m0 2C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12m-1-6h2v-8h-2zm1-12.25a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5"/></svg>`
);
